import React, { createContext, useContext, useState } from "react";

export const StatementContext = createContext();

/**
 * Custom hook to use the StatementContext.
 * 
 * @returns {object} The current statement context value.
 * @throws Will throw an error if used outside of a StatementProvider.
 */
export function useStatement() {
  const context = useContext(StatementContext);
  if (!context) {
    // Make sure to wrap the parent component with the StatementIDProvider in order to make use of the langauge context in the descending child nodes
    throw new Error("useStatementID must be used within a StatementIDProvider");
  }
  return context;
}

/**
 * StatementProvider component that provides the statement context to its children.
 * 
 * @param {React.ReactNode} children - The child components that will receive the statement context.
 * @returns {JSX.Element} The statement provider component with context.
 */
export const StatementProvider = ({ children }) => {
  const [statementID, setStatementID] = useState();

  /**
   * Clears the current statement ID
   */
  const clearStatementID = () => {
    setStatementID();
  }

  return (
    <StatementContext.Provider value={{ statementID, setStatementID, clearStatementID }}>
      {children}
    </StatementContext.Provider>
  );
};
